var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/other.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-51c36148!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/other.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Other.vue
// module id = 332
// module chunks = 1